"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styles = require("@material-ui/core/styles");
var _materialUiPopupState = _interopRequireWildcard(require("material-ui-popup-state"));
var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));
var _Menu = _interopRequireDefault(require("@material-ui/core/Menu"));
var _ListItemIcon = _interopRequireDefault(require("@material-ui/core/ListItemIcon"));
var _ListItemText = _interopRequireDefault(require("@material-ui/core/ListItemText"));
var _SttAppsButton = _interopRequireDefault(require("../../SttButton/SttAppsButton"));
var _common = require("../../imagens/icones-modulos/common");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    menuButton: {
      fontSize: theme.spacing(3),
      color: '#fff',
      margin: 'auto',
      width: 30,
      height: 30
    },
    iconeModulo: {
      width: 24,
      height: 24
    }
  };
});
var iconesModulos = (0, _common.importIconesModulos)('cinza');
function MenuModulosMobile(_ref) {
  var config = _ref.config;
  var classes = useStyles();
  var _useState = (0, _react.useState)([]),
    _useState2 = _slicedToArray(_useState, 2),
    modulos = _useState2[0],
    setModulos = _useState2[1];
  (0, _react.useEffect)(function () {
    var messageListener = function messageListener(e) {
      var _e$data, _e$data2;
      if (!e) return;
      var acao = ((_e$data = e.data) === null || _e$data === void 0 ? void 0 : _e$data.acao) || null;
      var data = ((_e$data2 = e.data) === null || _e$data2 === void 0 ? void 0 : _e$data2.data) || null;
      if (acao === 'MENU_MODULOS') {
        setModulos(JSON.parse(data.modulos));
      }
    };
    window.addEventListener('message', messageListener);
    return function () {
      window.removeEventListener('message', messageListener);
    };
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_materialUiPopupState["default"], {
    variant: "popover"
  }, function (popupState) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_SttAppsButton["default"], _extends({
      className: classes.menuButton,
      disableRipple: true,
      size: "small"
    }, (0, _materialUiPopupState.bindTrigger)(popupState))), /*#__PURE__*/_react["default"].createElement(_Menu["default"], (0, _materialUiPopupState.bindMenu)(popupState), modulos.map(function (m, index) {
      return /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
        key: index,
        onClick: function onClick() {
          popupState.close();
          window.open(m.url);
        }
      }, /*#__PURE__*/_react["default"].createElement(_ListItemIcon["default"], null, /*#__PURE__*/_react["default"].createElement("img", {
        className: classes.iconeModulo,
        src: iconesModulos[m.modulo]
      })), /*#__PURE__*/_react["default"].createElement(_ListItemText["default"], null, m.nome));
    })));
  }), /*#__PURE__*/_react["default"].createElement("iframe", {
    referrerPolicy: "unsafe-url",
    src: "".concat(config.url_base_oauth2, "/MenuModulosMobile"),
    style: {
      width: '0',
      height: '0',
      display: 'none'
    }
  }));
}
var _default = MenuModulosMobile;
exports["default"] = _default;